module.exports = __webpack_public_path__ + "dingbeauty-build/img/store2_big@2.8890068c.jpg";